<template>
  <div id="orderManagement">
    <div class="contentRight2">
      <div class="head" style="font-size: 15px; color: #707070">
        <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>
            <a href="javascript:;" @click="hrefOrder">订单管理</a>
          </el-breadcrumb-item>
          <el-breadcrumb-item>
            <a href="javascript:;" @click="hrefOrderDetail">订单详情</a>
          </el-breadcrumb-item>
          <el-breadcrumb-item>退货退款</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 表格 -->
      <div class="content" v-show="pageType == 1">
        <table class="table" width="100%" style="table-layout: fixed">
          <tr class="th">
            <td>
              <el-checkbox @change="total" v-model="totalClick" style="margin-right: 20px"
                >全选</el-checkbox
              >商品名称
            </td>
            <td>单价</td>
            <td>数量</td>
            <td>可退金额</td>
          </tr>
          <tr class="td" v-for="(item, index) in goodsList" :key="index">
            <td style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
              <div class="row alignCenter">
                <el-checkbox
                  @change="commidityClick(item, index)"
                  v-model="item.click"
                ></el-checkbox>
                <div>
                  <img
                    class="edit-item_img"
                    style="margin: 10px 10px"
                    :src="item.goodsImage"
                    alt
                  />
                </div>
                <div class="column">
                  <div class="edit-item_name">
                    {{ item.goodsName }}
                    <span v-if="item.specDesc">({{ item.specDesc }})</span>
                  </div>
                  <div class="edit-item_code">商品码：{{ item.goodsBarCode }}</div>
                </div>
              </div>
            </td>
            <td style="color: #ff8080">￥{{ item.turnoverPrice }}</td>
            <!-- 数量 -->
            <td>
              <el-input
                v-if="item.unitType == 1"
                v-model="item.qrcBuyCount"
                style="width: 100px"
                @input="goodsNumBlur(item, index)"
              ></el-input>
              <el-input
                v-if="item.unitType == 2"
                v-model="item.qrcBuyCount"
                type="number"
                style="width: 100px"
                @blur="goodNumBlur(item, index)"
              ></el-input>
            </td>
            <td>￥{{ item.totalTurnoverPrice }}</td>
          </tr>
        </table>
      </div>
      <div v-show="pageType == 2">
        <div class="editCom">
          <div class="edit-item" v-for="(item, index) in trueCommodity" :key="index">
            <div class="row">
              <div>退款商品：</div>
              <div class="row">
                <div>
                  <img class="edit-item_img" :src="item.goodsImage" alt />
                </div>
                <div class="column">
                  <div class="edit-item_name">{{ item.goodsName }}</div>
                  <div class="edit-item_code">商品码：{{ item.goodsBarCode }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div>退款金额：</div>
              <div class="column">
                <el-input
                  v-model.number="item.money"
                  type="number"
                  :max="10"
                  @input="inputChange(item, index)"
                  @blur="inputBlur(item, index)"
                ></el-input>
                <div class="edit-item_maxPrice">
                  最大可退金额￥{{ item.totalTurnoverPrice }}
                </div>
              </div>
            </div>
            <div class="row">
              <div>退货方式：</div>
              <el-select
                v-model="item.productSaleStatus"
                @change="update"
                placeholder="退换货方式"
              >
                <el-option
                  v-for="item2 in item.goodsId == 0 ? options3 : options"
                  :key="item2.value"
                  :label="item2.label"
                  :value="item2.value"
                ></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="row cause alignCenter" style="background: #eee">
          退款原因：
          <div
            v-for="(item, index) in causeList"
            @click="causeClick(item, index)"
            :key="index"
            class="center"
            :class="item.isClick ? 'refundCause2' : 'refundCause'"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="cause row" style="margin-bottom: 100px; background: #eee">
          退款说明：
          <el-input
            :rows="3"
            maxlength="200"
            show-word-limit
            style="width: 400px"
            type="textarea"
            v-model="remark"
          ></el-input>
        </div>
      </div>
      <div class="button row flex-between">
        <div v-show="pageType == 1"></div>
        <div class="button-next row alignCenter" v-show="pageType == 1">
          <div class="button-text">
            已选
            <span style="color: blue; margin: 0 5px">{{ trueCommodity.length }}</span
            >件商品
          </div>
          <el-button type="primary" @click="nextGo" :disabled="trueCommodity.length == 0"
            >下一步</el-button
          >
        </div>
        <div></div>
        <div class="button-next row alignCenter" v-show="pageType == 2">
          <div class="row alignCenter" v-show="pageType == 2" style="margin-right: 20px">
            <!-- <div>结算方式：线上支付原路返回</div> -->
            <el-select
              v-model="isCashPay"
              @change="update"
              placeholder="选择结算方式"
              v-if="payInterfacePartyType1"
            >
              <el-option
                v-for="item in options2"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div
            class="row alignCenter"
            v-show="pageType == 2"
            style="margin-right: 20px"
            v-if="this.payInterfacePartyType2"
          >
            <div>结算方式：线下退款</div>
          </div>
          <div
            class="row alignCenter"
            v-show="pageType == 2"
            style="margin-right: 20px"
            v-if="this.payInterfacePartyType3"
          >
            <div>结算方式：线上支付原路返回</div>
          </div>
          <div class="button-text">
            退还给买家
            <span style="color: red; margin: 0 5px" v-if="totalPrice && totalMoney"
              >￥{{ totalPrice.toFixed(2) }}</span
            >
            <span style="color: red; margin: 0 5px" v-if="totalPrices"
              >￥{{ totalPrices.toFixed(2) }}</span
            >
          </div>
          <el-button type="primary" @click="saveMallOrderRefund">确认退款</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { saveMallOrderRefund, refundSelectProductList } from "../api";
import crypto from "crypto";
export default {
  data() {
    return {
      isCashPay: null, //选择结算方式
      causeType: 0, //原因选中下标
      goodsList: [],
      totalClick: false, //全选
      trueCommodity: [],
      pageType: 1,
      causeList: [
        { name: "质量问题", id: 1, isClick: false },
        { name: "不想要了", id: 2, isClick: false },
        { name: "破损/缺件", id: 3, isClick: false },
        { name: "买错/多买", id: 4, isClick: false },
        { name: "其他", id: 5, isClick: false },
      ], //
      remark: "",
      totalPrice: 0,
      totalPrices: 0,
      options: [
        {
          value: 6,
          label: "仅退款",
        },
        {
          value: 1,
          label: "退货退款",
        },
      ],
      options3: [
        {
          value: 6,
          label: "仅退款",
        },
      ],
      options2: [
        {
          value: 1,
          label: "线下退款",
        },
        {
          value: 0,
          label: "线上支付原路返回",
        },
      ],
      value: "",
      payInterfacePartyType: "",
      payInterfacePartyType1: false,
      payInterfacePartyType2: false,
      payInterfacePartyType3: false,
      goodsNum: "",
      goodsNums: "",
      totalMoney: true,
    };
  },
  created() {
    this.payInterfacePartyType = localStorage.getItem("payInterfacePartyType");
    if (this.payInterfacePartyType == 2 || this.payInterfacePartyType == 3) {
      this.payInterfacePartyType1 = true;
    } else if (this.payInterfacePartyType == 10) {
      this.payInterfacePartyType3 = true;
      this.isCashPay = 0;
    } else {
      this.payInterfacePartyType2 = true;
      this.isCashPay = 1;
    }
    console.log(this.payInterfacePartyType, "this.payInterfacePartyType");
    this.goods();
  },
  methods: {
    goodsNumBlur(item, index) {
      let reg = /^[1-9]\d*$/;
      for (var i = 0; i < this.goodsList.length; i++) {
        if (item.mallOrderProductId == this.goodsList[i].mallOrderProductId) {
          if (item.qrcBuyCount > this.goodsList[i].goodsNums) {
            item.qrcBuyCount = this.goodsList[i].goodsNums;
            this.$message.error("退款数量不能大于购买数量");
          } else if (item.qrcBuyCount < 0) {
            this.$message.error("退款数量不能小于0");
            item.qrcBuyCount = this.goodsList[i].goodsNums;
          } else if (!reg.test(item.qrcBuyCount)) {
            this.$message.error("请输入正确的退款数量");
            item.qrcBuyCount = "";
          }
        }
        this.goodsList[index].totalTurnoverPrice = (
          this.goodsList[index].turnoverPrice * this.goodsList[index].qrcBuyCount
        ).toFixed(2);
      }
    },
    goodNumBlur(item, index) {
      item.qrcBuyCount = Number(item.qrcBuyCount).toFixed(3);
      let reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      for (var i = 0; i < this.goodsList.length; i++) {
        if (item.mallOrderProductId == this.goodsList[i].mallOrderProductId) {
          if (item.qrcBuyCount > this.goodsList[i].goodsNums) {
            item.qrcBuyCount = this.goodsList[i].goodsNums;
            this.$message.error("退款数量不能大于购买数量");
          } else if (item.qrcBuyCount < 0) {
            this.$message.error("退款数量不能小于0");
            item.qrcBuyCount = this.goodsList[i].goodsNums;
          } else if (!reg.test(item.qrcBuyCount)) {
            this.$message.error("请输入正确的退款数量");
            item.qrcBuyCount = "";
          }
        }
        this.goodsList[index].totalTurnoverPrice = (
          this.goodsList[index].turnoverPrice * this.goodsList[index].qrcBuyCount
        ).toFixed(2);
      }
    },
    saveMallOrderRefund() {
      // if (this.isCashPay == null) {
      //   this.$message.error("请选择结算方式");
      //   return;
      // }

      var SproductJson = [];
      var isRufundGoods = false;
      for (let i in this.trueCommodity) {
        SproductJson.push({
          mallOrderProductId: this.trueCommodity[i].mallOrderProductId,
          money: this.trueCommodity[i].money,
          productSaleStatus: this.trueCommodity[i].productSaleStatus,
          goodsNum: this.trueCommodity[i].qrcBuyCount,
        });
        if (Number(this.trueCommodity[i].money) <= 0) {
          this.$message.error(
            "商品" + this.trueCommodity[i].goodsName + "退款金额不得小于等于0"
          );
          return;
        } else if (!this.trueCommodity[i].productSaleStatus) {
          this.$message.error(
            "请选择商品" + this.trueCommodity[i].goodsName + "的退款方式"
          );
          return;
        }
      }
      SproductJson.forEach((e) => {
        if (e.productSaleStatus == 1) {
          isRufundGoods = true;
        }
      });
      this.$prompt("请输入密码", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputType: "password",
      })
        .then(({ value }) => {
          var passWord = value;
          var md5 = crypto.createHash("md5");
          md5.update(passWord);
          passWord = md5.digest("hex");
          passWord = passWord.toUpperCase();
          var refundRemark = "";
          this.causeList.forEach((a) => {
            if (a.isClick) {
              refundRemark += a.name + ",";
            }
          });
          if (this.remark) {
            refundRemark += this.remark;
          } else {
            refundRemark = refundRemark.substring(0, refundRemark.lastIndexOf(","));
          }
          saveMallOrderRefund({
            mallOrderId: this.$route.query.id, //订单id
            //  handlerId:123, //经手人ID
            isCashPay: this.isCashPay, //1:是使用现金退款 0：线上支付原路返回
            refundMoney: this.totalPrices ? this.totalPrices : this.totalPrice, //退款，退了多少钱
            managerPassWord: passWord, //密码  （需输入登录密码）(密码要MD5加密)
            // String businessTime //业务日期（退货日期）
            refundRemark: refundRemark, //备注
            productJson: JSON.stringify(SproductJson),
          })
            .then((res) => {
              if (res.code == 1) {
                // this.$message({
                //   type: "success",
                //   message: "退款成功"
                // });
                var refundOrderId = res.data.refundOrderId;
                if (isRufundGoods) {
                  this.$confirm("退货退款成功，是否将已退货商品进行入库操作", "提示", {
                    confirmButtonText: "退货商品重新入库",
                    cancelButtonText: "取消",
                    //   type: "warning"
                  })
                    .then(() => {
                      this.$router.push({
                        path: "/order/returnOfTheTreasury",
                        query: {
                          refundOrderId: refundOrderId,
                          mallOrderId: this.$route.query.id,
                        },
                      });
                    })
                    .catch(() => {
                      this.hrefOrder();
                    });
                } else {
                  this.$message({
                    type: "success",
                    message: "退货成功",
                  });
                  this.hrefOrder();
                }
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch(function (error) {
              alert("网络错误，不能访问");
              console.log(error);
            });
        })
        .catch((e) => {
          console.log(e);
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    //下一步
    nextGo() {
      this.pageType = 2;
      this.totalPrice = 0;
      // let data = JSON.parse(JSON.stringify(this.trueCommodity))
      // console.log(data, 123)
      for (let i = 0; i < this.trueCommodity.length; i++) {
        this.trueCommodity[i].money = Number(this.trueCommodity[i].totalTurnoverPrice);
      }
      this.trueCommodity.forEach((element) => {
        this.totalPrice += Number(element.money);
      });
    },
    //退款金额改变
    inputChange(item, index) {
      // console.log(item, index, 444444444444444)
      if (item.money > item.totalTurnoverPrice) {
        this.trueCommodity[index].money = item.totalTurnoverPrice;
      }
      if (Number(item.money) <= 0) {
        this.$message.error("退款金额不得小于等于0");
        item.money = "";
      }
      this.update();
    },
    inputBlur(item, index) {
      this.totalPrices = 0;
      this.trueCommodity.forEach((element) => {
        console.log(element, "element");
        this.totalPrices += Number(element.money);
      });
      this.totalMoney = false;
      // this.update();
    },
    update() {
      console.log("更新");
      var arr = this.goodsList;
      this.goodsList = "";
      this.goodsList = arr;
    },
    causeClick(item, index) {
      // this.causeType = item.id;
      this.causeList[index].isClick = !this.causeList[index].isClick;
    },
    total() {
      this.goodsList.forEach((element) => {
        element.click = this.totalClick;
      });
      if (this.totalClick) {
        this.trueCommodity = [];
        this.goodsList.forEach((element) => {
          this.trueCommodity.push(element);
        });
      } else {
        this.trueCommodity = [];
      }
    },
    commidityClick(item, index) {
      console.log(item, index);
      var arr = this.goodsList;
      var trueCommodity = this.trueCommodity;
      console.log(item.click, "商品是否选中状态");
      if (item.click == false) {
        this.totalClick = false;
        for (let i in this.trueCommodity) {
          if (this.trueCommodity[i].mallOrderProductId == item.mallOrderProductId) {
            trueCommodity.splice(i, 1);
          }
        }
      } else {
        this.totalClick = arr.every((item1) => {
          return item1.click;
        });
        trueCommodity.push(item);
      }

      //因为goodslist click值变化 界面checkbox状态不变
      this.goodsList = "";
      this.goodsList = arr;
      this.trueCommodity = trueCommodity;
      //
    },
    // 跳转订单界面
    hrefOrder() {
      this.$router.push("/order/offline");
    },
    hrefOrderDetail() {
      this.$router.go(-1);
    },
    goods(item) {
      var id = this.$route.query.id;
      console.log(id, "id");
      //商品列表
      refundSelectProductList({
        mallOrderId: id,
        row: 9999,
        pageNo: 1,
      }).then((res) => {
        console.log(res, "商品列表哦");
        this.goodsList = res.data;
        var goodsList = this.goodsList;
        var qrcBuyCount = 0;
        var retailPrice = 0;
        var totalDiscounts = 0;

        for (let j in goodsList) {
          qrcBuyCount += goodsList[j].qrcBuyCount;
          retailPrice += goodsList[j].totalTurnoverPrice;
          totalDiscounts +=
            (goodsList[j].retailPrice - goodsList[j].turnoverPrice) *
            goodsList[j].qrcBuyCount;
          goodsList[j].click = false;
          goodsList[j].money = goodsList[j].totalTurnoverPrice;
          goodsList[j].productSaleStatus = null;
          goodsList[j].goodsNums = goodsList[j].qrcBuyCount;
        }
        this.$set(this.goodsList, "totalCount", qrcBuyCount);
        this.$set(this.goodsList, "totalRetailPrice", retailPrice);
        this.$set(this.goodsList, "totalDiscounts", totalDiscounts);
        this.goodsList = this.goodsList;
        console.log(this.goodsList, "123");
      });
    },
  },
};
</script>

<style scoped>
.cause {
  padding: 30px;
  font-size: 14px;
  color: #666666;
}
.refundCause2 {
  width: 81px;
  height: 34px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid #108ee9;
  border-radius: 3px;
  color: #108ee9;
  margin-right: 10px;
}
.refundCause {
  width: 81px;
  height: 34px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(204, 204, 204, 1);
  border-radius: 3px;
  margin-right: 10px;
}
.edit-item_maxPrice {
  color: #999999;
  font-size: 12px;
  margin-top: 10px;
}
.edit-item > .row {
  padding-bottom: 20px;
}
.edit-item:not(:first-child) {
  margin-top: 30px;
}
.edit-item {
  border-bottom: 1px solid #eee;
}
.edit-item_code {
  color: #999;
  margin-top: 15px;
}
.edit-item_name {
  color: #333333;
}
.edit-item_img {
  height: 65px;
  width: 65px;
  margin-right: 20px;
}
.editCom {
  max-height: 500px;
  overflow-y: scroll;
  margin: 30px;
  font-size: 14px;
  color: #666666;
}
.button-text {
  margin-right: 20px;
}
.button-next {
  float: right;
  margin-right: 50px;
}
.button {
  position: fixed;
  bottom: 0;
  width: calc(100vw - 217px);
  padding: 30px;
  background: #fff;
  border-top: 1px solid #eee;
}
.th {
  background: #f8f8f8;
  padding: 15px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #909399;
  font-weight: 600;
}

.th td {
  font-size: 14px;
  border-bottom: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
  text-align: center;
}
.th td:first-child {
  text-align: left;
  padding-left: 17px;
}
.th td:last-child {
  text-align: right;
  padding-right: 28px;
}
td {
  font-size: 14px;
  padding: 0;
  margin: 0;
  /* width: 25%; */
}
table {
  border: 0;
  border-collapse: 0;
  border-spacing: 0;
  font-size: 14px;
}
.td td {
  height: 55px;
  border-bottom: 1px solid #ebeef5;
  text-align: center;
  word-break: keep-all; /* 不换行 */
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容 */
  text-overflow: ellipsis; /* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用*/
}

.td td:first-child {
  text-align: left;
  padding-left: 17px;
}
.td td:last-child {
  padding-right: 30px;
  text-align: right;
}
.table {
  width: 100%;
  font-size: 12px;
}
.content {
  /* box-sizing: border-box; */
  width: 100%;
  /* height: 100%; */
  /* width: calc(100vw - 250px); */
  height: 750px;
  overflow-y: scroll;
  /* padding: 30px; */
  color: #606266;
  font-size: 14px;
}
.head {
  box-sizing: border-box;
  padding: 14px 25px;
  background: #f8f8f8;
  width: 100%;
}
</style>
